import { themeButtons } from './lib/elements.js'
import { applyThemeSetting, toggleThemeSetting } from './lib/dark-theme.js'

// Apply user theme settings on load
applyThemeSetting()

// Change theme on button click
themeButtons.forEach((item) =>
	item.addEventListener('click', (e) => {
		applyThemeSetting(toggleThemeSetting(e))
	})
)
